import { useInstantSearch } from 'react-instantsearch'

import { useTranslate } from 'hooks'
import usePrevious from 'hooks/use-previous'

import css from './hit-result-title.module.scss'

const HitResultTitle = ({ searchText }: { searchText: string | string[] }) => {
  const { t } = useTranslate('strapi-search-[...term]')
  const { results, status } = useInstantSearch()
  const prevStatus = usePrevious(status)

  const hasNoResult = results.nbHits === 0 && status === 'idle' && (prevStatus === 'loading' || prevStatus === 'idle')
  return (
    <div className={css.container}>
      {hasNoResult ? (
        <span className={css.noResultMessageTxt}>{`${t(
          'PageSearch.PageSearch_Filters_no_results_desc'
        )} "${searchText.toString()}"`}</span>
      ) : (
        <>
          <span className={css.resultHeaderFor}>{t('PageSearch.PageSearch_Filters_results_for')}</span>
          <span className={css.resultSearchText}> &quot;{searchText}&quot;</span>
        </>
      )}
    </div>
  )
}

export default HitResultTitle
